module.exports = "/assets/data/2d40f9b15b3734f2360615016378aa4a-MK3.data.json";